import { OverlayRef } from '@angular/cdk/overlay';
import { BodyReportDamageComponent } from './body-report-damage.component';
import { Subject, Observable } from 'rxjs';

export class BodyReportDamageOverlayRef {
  constructor(private overlayRef: OverlayRef) {}
  componentInstance: BodyReportDamageComponent;
  private _beforeClose = new Subject<void>();
  private _afterClosed = new Subject<void>();
  private _afterDelete = new Subject<void>();
  close(): void {
    this._afterClosed.next(this.componentInstance.selectedElement);
    this._afterClosed.complete();
    this.overlayRef.dispose();
    this.componentInstance = null!;
  }
  cancel(): void {
    this.overlayRef.dispose();
  }

  delete() {
    this._afterDelete.next(this.componentInstance.selectedElement);
    this._afterDelete.complete();
    this.overlayRef.dispose();
    this.componentInstance = null!;
  }

  afterClosed(): Observable<any> {
    return this._afterClosed.asObservable();
  }

  afterDelete(): Observable<any> {
    return this._afterDelete.asObservable();
  }

  beforeClose(): Observable<void> {
    return this._beforeClose.asObservable();
  }
}
